// extracted by mini-css-extract-plugin
export default {"productDescription":"H_-z","featuredDescription":"I_-z","description":"J_-z","more":"K_-z","descriptionSku":"L_-z"};